/** What a clerk has typed and ticked so far on a bank's reconcile page. */
export interface ReconcileDraft {
  statementDate: string;
  statementBalance: string;
  ticks: Record<number, string>;
  notes: string;
}

/*
  Kept in sessionStorage so a clerk who leaves for Expenses to record the bank's charges comes back
  to the same ticks — a month's statement is twenty or thirty lines. A per-person convenience only:
  the record is the server's, and a blocked or empty store simply starts the page fresh.
*/
const storageKey = (accountId: number) => `attirerent:reconcile:${accountId}`;

export function freshDraft(today: string): ReconcileDraft {
  return { statementDate: today, statementBalance: '', ticks: {}, notes: '' };
}

export function loadReconcileDraft(accountId: number, today: string): ReconcileDraft {
  const fresh = freshDraft(today);

  try {
    const stored = window.sessionStorage.getItem(storageKey(accountId));

    return stored ? { ...fresh, ...(JSON.parse(stored) as Partial<ReconcileDraft>) } : fresh;
  } catch {
    return fresh;
  }
}

export function saveReconcileDraft(accountId: number, draft: ReconcileDraft) {
  try {
    window.sessionStorage.setItem(storageKey(accountId), JSON.stringify(draft));
  } catch {
    // A private window or a full store: the page still works, it just will not remember.
  }
}

/** After a save or a Cancel — the ticks belong to a statement that is now done or abandoned. */
export function clearReconcileDraft(accountId: number) {
  try {
    window.sessionStorage.removeItem(storageKey(accountId));
  } catch {
    // Nothing to clear.
  }
}
